import classNames from 'classnames';
import React from 'react';

const styles = require('./state.module.scss');

interface Props {
  className?: string;
  state: boolean;
  labelTrue: string;        // text when state = true
  labelFalse: string;       // text when state = false
}

export default function Status(props: Props) {
  const { state, labelTrue, labelFalse } = props;

  const label = state ? labelTrue : labelFalse;
  const stateClass = state ? styles['state-ok'] : styles['state-nok'];

  return (
    <span className={classNames(styles.container, props.className)}>
      <span className={classNames(styles.circle, stateClass)} />
      <span className={styles.label}>{label}</span>
    </span>
  );
}